import u from "./utilities";
function licenceDate(l) {
  let start = "";
  let end = "";
  if (l.StartDate != null) {
    start = l.StartDate;
  }
  if (l.SeasonStartDate != null) {
    start = l.SeasonStartDate;
  }
  //temp fix for patentdate change 2023
  if (l.SeasonStartDate === "2024-01-01T00:00:00") {
    start = "2023-12-26T00:00:00";
  }

  if (l.EndDate != null) end = l.EndDate;
  let out = [];
  if (start != "") {
    let sd = new Date(start);
    out.push(sd.toLocaleDateString("de-CH"));
  }
  if (end != "") {
    let ed = new Date(end);
    out.push(ed.toLocaleDateString("de-CH"));
  }
  return out.join(" - ");
}

function setTime() {
  return new Date().toLocaleTimeString("de-CH");
}

// return licence url
function licenceUrl(url, q) {
  let out = url;
  if (location.origin.indexOf("localhost:80") > -1)
    out = location.origin + "/getlicenseproducts.json";
  return out.indexOf("?") > -1 ? out + q.replace("?", "&") : out + q;
}
// set base url
function getBaseUrl() {
  let base = location.origin;
  if (base.indexOf("localhost:80") > -1)
    base = "https://shop.fischerparadies.ch";
  return base;
}

function testGuest(str) {
  var guestPattern = /gäste/gim;
  return guestPattern.test(str);
}

function logentriesUrl(url) {
  let now = Date.now();
  let out = url;
  if (location.origin.indexOf("localhost:80") > -1)
    out = location.origin + "/getlogentriesforcurrentuser.json?ok=1";
  return u.updateQueryStringParameter(out, "v", now);
}

function sortByDate(data) {
  return data.sort((a, b) => {
    return new Date(b.UsedOn) - new Date(a.UsedOn);
  });
}
function buildLicenseData(data) {
  let out = [];
  console.log(data);
  if (data.length) {
    let ndata = data.map((d) => {
      if (d.Attributes) {
        var pattern = /gästekarte\":\"ja/gi;
        d.guestcard = pattern.test(d.Attributes);
      }
      return d;
    });
    out = ndata.filter((d) => {
      let date = d.StartDate ? new Date(u.dstrip(d.StartDate)) : null;
      let guest = testGuest(d.ProductName);
      if (d.EndDate) date = new Date(u.dstrip(d.EndDate));
      if (d.SeasonStartDate) {
        let seasonStartdate = new Date(u.dstrip(d.SeasonStartDate));

        let enddate = new Date(
          new Date(new Date(seasonStartdate.setMonth(11)).setDate(31))
        );
        /*  console.log("enddate1", date); */
        let month = seasonStartdate.getMonth();
        let day = seasonStartdate.getDate();
        // fix the issue with licence startdate xxxx-01-01
        // console.log("day", day);
        // console.log("month", month);
        if (month !== 0 && day !== 1) {
          enddate.setFullYear(seasonStartdate.getFullYear() + 1);
        }
        date = enddate;

        // console.log("enddate", date);
      }

      //temp fix for patentdate change 2023
      /* if (d.SeasonStartDate === "2024-01-01T00:00:00") {
        let enddate = new Date(
          new Date(new Date(u.dstrip(d.SeasonStartDate)).setMonth(11)).setDate(
            31
          )
        );
        date = enddate;
      } */
      return date && u.dateToIso(date) >= u.dateToIso(u.today());
    });
    console.log("buildLicenseData", out);
  }
  return out;
}

export {
  licenceDate,
  setTime,
  licenceUrl,
  getBaseUrl,
  testGuest,
  logentriesUrl,
  sortByDate,
  buildLicenseData,
};
